<template>
    <div>
        <div>
            <!-- Modal for creating a new stamp -->
            <PersonalStampIterationModal @reload:stamp="$emit('reload:stamp', $event)" />
            <!-- General warning information modal (errors and such) -->
            <WarningInformationModal />
            <GenericConfirmationModal :style="{zIndex: 100000}" />
            <PublishRosterModal />
            <CompanyEmployeeDetailsModal />
            <GlobalErrorModal />
        </div>
        <Notify />
    </div>
</template>

<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator';
    import PersonalStampIterationModal from '@/components/modals/PersonalStampIterationModal.vue';
    import GenericConfirmationModal from '@/components/modals/GenericConfirmationModal.vue';
    import PublishRosterModal from '@/components/modals/PublishRosterModal.vue';
    import CompanyEmployeeDetailsModal from '@/components/modals/CompanyEmployeeDetailsModal.vue';
    import WarningInformationModal from '@/components/modals/WarningInformationModal.vue';
    import Notify from '@/components/modals/Notify.vue';
    import GlobalErrorModal from '@/components/modals/GlobalErrorModal.vue';

    @Component({
        components: {
            PersonalStampIterationModal,
            GenericConfirmationModal,
            PublishRosterModal,
            CompanyEmployeeDetailsModal,
            WarningInformationModal,
            Notify,
            GlobalErrorModal,
        },
        emits: ['reload:stamp'],
    })
    export default class Modals extends Vue {

    }
</script>
